import { ErrorMessage } from '@hookform/error-message'
import React, { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { dt } from 'Root/Shared/utils/dynamicRS'

import { FormFieldInputType } from '../builders/FormBuilder'
import { WidgetProperitesPart } from '../builders/WidgetBuilder'
import FormErrorHelper from './FormErrorHelper'
import {
  getClass,
  getRequiredField,
  replaceResourceStrings,
} from './formFieldHelper'

const FormFieldCheckboxWidget: React.FC<{
  props: FormFieldInputType
  widgetProperties?: WidgetProperitesPart
}> = ({ props, widgetProperties }) => {
  const formElement = props?.puxFormElement
  const formValidation = props?.puxFormElementValidation
  const formOptions = props?.puxFormElementOptions

  const [checked, setChecked] = useState<boolean>(
    props?.puxFormElement.formElementDefaultValue === `checked`
  )

  const inputId =
    formElement?.formElementID ||
    formElement?.formElementName ||
    props.displayText

  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <div
      className={`FormGroup ${
        formOptions?.formElementOptionsCssClass ?? ``
      } ${getClass(
        props?.metadata?.size,
        widgetProperties
      )} FormGroup--checkboxInput`}
    >
      <div className='FormGroup-centered'>
        <Controller
          name={formElement?.formElementName}
          control={control}
          rules={{
            required: formValidation.formElementValidationRequired
              ? dt(`PuxForm.Error.Required`)
              : false,
          }}
          render={({ field }) => (
            <>
              <input
                {...field}
                name={formElement?.formElementName}
                id={inputId}
                type={props?.inputType}
                placeholder={replaceResourceStrings(
                  formElement?.formElementPlaceholder
                )}
                disabled={formOptions?.formElementOptionsDisabled}
                className={formOptions?.formElementOptionsCssClass ?? ``}
                checked={checked}
                onChange={(event) => {
                  setChecked(event.target.checked)
                  field.onChange(event.target.checked)
                }}
              />
              <label htmlFor={inputId}>
                <div className='fake-check'>
                  {replaceResourceStrings<React.ReactNode>(
                    formElement?.formElementLabel,
                    true
                  )}
                  {getRequiredField(
                    props?.puxFormElementValidation
                      ?.formElementValidationRequired
                  )}
                </div>
              </label>
            </>
          )}
        />
        <ErrorMessage
          render={(data) => <FormErrorHelper {...data} />}
          errors={errors}
          name={
            formElement?.formElementName ? formElement?.formElementName : ``
          }
        />
      </div>
    </div>
  )
}

export default FormFieldCheckboxWidget
